<template>
  <div class="wrapper" @mouseenter="on_enter" @mouseleave="on_leave">
    <swiper :options="swiperOption" ref="mySwiper" v-if='swiperList.length'>
      <swiper-slide v-for="item in swiperList" :key="item.id">
        <div class="item">
          <img :src="item.url"/>
          <div class="des">
            <div class="en">
              <p>{{$t("home.poster.en.title1")}}<img src="~assets/common/logo-small.png"/></p>
              <p>{{$t("home.poster.en.title2")}}</p>
            </div>
            <div class="cn">
              <p class="title">{{getLang === 'zh' ? item.title : item.fantiTitle}}</p>
              <p class="text">{{getLang === 'zh' ? item.documents : item.fantiDocuments}}</p>
              <p class="icon">+</p>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination swiper-pagination-home"  slot="pagination"></div>
      <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
      <div class="swiper-button-next swiper-btn" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'HomSwiper',
  data () {
    return {
      swiperOption: {
        autoHeight: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true,
        mousewheel: false,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination-home'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        onSlideChangeEnd: swiper => {
          swiper.update()
        }
      },
      swiperList: [],
      defaultList: [
        {
          id: '1',
          title: '细节品质，用心呈现',
          documents: '新福港一直努力做好每一个细节，并不断钻研建筑细节对生活品质的提升，创造性地运用设计、技术和服务，为不同消费者提供理想的生活空间和高品质、高品位的丰盛生活。',
          fantiTitle: '細節品質，用心呈現',
          fantiDocuments: '新福港一直努力做好每一個細節，並不斷鑽研建築細節對生活品質的提昇，創造性地運用設計、技術和服務，爲不同消費者提供理想的生活空間和高品質、高品位的豐盛生活。',
          url: 'static/images/home/poster1.jpg'
        },
        {
          id: '2',
          title: '细节品质，用心呈现',
          documents: '新福港一直努力做好每一个细节，并不断钻研建筑细节对生活品质的提升，创造性地运用设计、技术和服务，为不同消费者提供理想的生活空间和高品质、高品位的丰盛生活。',
          fantiTitle: '細節品質，用心呈現',
          fantiDocuments: '新福港一直努力做好每一個細節，並不斷鑽研建築細節對生活品質的提昇，創造性地運用設計、技術和服務，爲不同消費者提供理想的生活空間和高品質、高品位的豐盛生活。',
          url: 'static/images/home/poster2.jpg'
        },
        {
          id: '3',
          title: '细节品质，用心呈现',
          documents: '新福港一直努力做好每一个细节，并不断钻研建筑细节对生活品质的提升，创造性地运用设计、技术和服务，为不同消费者提供理想的生活空间和高品质、高品位的丰盛生活。',
          fantiTitle: '細節品質，用心呈現',
          fantiDocuments: '新福港一直努力做好每一個細節，並不斷鑽研建築細節對生活品質的提昇，創造性地運用設計、技術和服務，爲不同消費者提供理想的生活空間和高品質、高品位的豐盛生活。',
          url: 'static/images/home/poster3.jpg'
        }
      ]
    }
  },
  computed: {
    getLang () {
      return this.$store.state.lang
    },
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    on_enter () {
      this.mySwiper.autoplay.stop()
    },
    on_leave () {
      this.mySwiper.autoplay.start()
    }
  },
  created () {
    // 请求海报
    // this.$axios.get('http://localhost:8088/api/xinfugang/home/page/list')
    this.$axios.get('https://www.sfkp.cn/api/xinfugang/home/page/list')
    // this.$axios.get('http://223.4.157.105:8081/api/xinfugang/home/page/list')
      .then(res => {
        // 连接成功后对数据长度<0的情况下
        if (res.data.data.length <= 0) {
          this.$message({
            message: '获取海报数量为0，请检查后台是否正确上传海报内容！',
            type: 'warning'
          })
          this.swiperList = this.defaultList
          return false
        }
        // 连接成功后对数据长度>=0的情况下
        this.swiperList = res.data.data
        // console.log(this.swiperList)
      })
      .catch(error => {
        this.swiperList = this.defaultList
        this.$message({
          message: '网络连接失败，请检查网络状况，或稍后再试！',
          type: 'warning'
        })
        console.log(error)
      })
  },
  mounted () {
  }
}
</script>
<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper >>> .swiper-pagination-bullet-active
    background #fff
  .wrapper >>> .swiper-pagination-bullet
    width 15px
    height 15px
  .wrapper >>> .swiper-pagination-bullets
    swiper-pagination-bullets
    /*bottom 0
    top 53%*/
  .swiper-btn
    background rgba(0,0,0,0.3)
    background-repeat no-repeat
    background-size cover
    border-radius 3px
    padding 4px 4px
    opacity 0
    transition opacity 1s
    /*top 30%*/
  .swiper-button-prev
    background-image url("~assets/common/width-64-left.png")
    background-position center left
  .swiper-button-next
    background-image url("~assets/common/width-64-right.png")
    background-position center right
  .wrapper
    width 100%
    /*height 0
    overflow hidden
    padding-bottom 41.66%*/
    :hover .swiper-btn
      opacity 1
    img
      width 100%
    .item
      position relative
      .des
        position absolute
        top 0
        left 18.75%
        width 62.5%
        height 100%
        color #FFF
        z-index 2
        img
          width 71px
        .en
          en()
          position relative
          font-size 80px
          line-height 90px
          // padding 177px 0 30px 0
          padding 15% 0 2.5% 0
        .en:after
          afterBottom()
          width 56px
          height 8px
          background #FFF
        .cn
          position relative
          .title
            font-size 40px
            font-family "Source Han Sans CN Normal"
            line-height 62px
            // padding 28px 0 20px
            padding 2.3% 0 1.6%
          .text
            width 58%
            font-size 16px
            font-family "Source Han Sans CN Normal"
            line-height 35px
          .icon
            font-size 50px
            padding-top 1.6
  @media screen and (max-width: 1440px) {
    .text {
      width 80%!important
    }
  }
  @media screen and (max-width: 1200px) {
    .text {
      width 85%!important
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Swiper.vue